/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationOfferGroupProtectionQuery = gql`
  query GetSimulationOfferGroupProtectionQuery {
    getSimulationOfferGroupProtection_simulation_offer_group_protection {
      products {
 code  
name  
isSelected  
status  
}
    }
  }
`;

export default GetSimulationOfferGroupProtectionQuery;
